import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ForumLeadData, ForumLeadResponse, ForumStats } from '../models/forum.models';

@Injectable({
  providedIn: 'root',
})
export class ForumService {
  private readonly baseUrl = environment.apiUrl;
  private http = inject(HttpClient);

  // État de la modale de capture
  private showForumModalSubject = new BehaviorSubject<boolean>(false);
  public showForumModal$ = this.showForumModalSubject.asObservable();

  // Données du trip en cours pour la modale
  private currentTripDataSubject = new BehaviorSubject<{tripName: string, co2: number} | null>(null);
  public currentTripData$ = this.currentTripDataSubject.asObservable();

  /**
   * Crée un lead forum
   */
  createForumLead(data: ForumLeadData): Observable<ForumLeadResponse> {
    return this.http.post<ForumLeadResponse>(`${this.baseUrl}/forum/leads`, data).pipe(
      tap(() => {
        this.hideForumModal();
      })
    );
  }

  /**
   * Récupère les statistiques forum
   */
  getForumStats(eventName: string = 'forum-2025'): Observable<ForumStats> {
    return this.http.get<ForumStats>(`${this.baseUrl}/forum/stats`, {
      params: { eventName }
    });
  }

  /**
   * Affiche la modale de capture avec les données du trip
   */
  showForumModal(tripName: string, co2Calculated: number): void {
    this.currentTripDataSubject.next({ tripName, co2: co2Calculated });
    this.showForumModalSubject.next(true);
  }

  /**
   * Masque la modale de capture
   */
  hideForumModal(): void {
    this.showForumModalSubject.next(false);
    // Effacer les données après un court délai pour permettre l'animation
    setTimeout(() => {
      this.currentTripDataSubject.next(null);
    }, 300);
  }

  /**
   * Récupère les données du trip actuel
   */
  getCurrentTripData(): {tripName: string, co2: number} | null {
    return this.currentTripDataSubject.value;
  }
}